import { Component, OnInit, AfterViewChecked, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseComponent } from "app/components/base.component";
import { AdminlistService, Adminlist } from "app/services/adminlist.service";
import { NgForm } from "@angular/forms";
import { NotificationsService } from "angular2-notifications";
import { FirebaseService } from "app/services/firebase.service";

@Component({
	selector: 'app-adminlist-add-edit',
	templateUrl: './adminlist-add-edit.component.html',
	styleUrls: ['./adminlist-add-edit.component.css'],
	providers: [AdminlistService],
})
export class AdminlistAddEditComponent extends BaseComponent implements OnInit {
	item: Adminlist;
	param_id: string;
	loading;
	fb_error;

	adminForm: NgForm;
	@ViewChild('adminForm') currentForm: NgForm;

	formTitle = 'Add New Admin';
	buttonText = 'Save Admin';

	constructor(
		private adminlistService: AdminlistService,
		private router: Router,
		private route: ActivatedRoute,
		private notificationsService: NotificationsService,
		private firebaseService: FirebaseService
	) {
		super();
	}

	ngOnInit() {
		var self = this;
		this.item = new Adminlist();
		this.param_id = this.route.snapshot.params["id"];
		if (this.param_id) {
			this.adminlistService.getAdmin(this.param_id).subscribe(admin => {
				this.item = Object.assign(new Adminlist(), admin);
				this.formTitle = "Edit Admin";
				this.buttonText = "Update Admin";
			});
		}
	}

	formAction(){
		if(this.formValidation(false)){
			if(this.param_id){
				this.loading = 'true';
				this.adminlistService.updateAdmin(this.param_id, this.item).then(() => {
					this.router.navigate(["/adminlist"]);
					this.loading = '';
					this.notificationsService.success('Updated', 'Admin updated')
				}).catch(reason => {
					this.fb_error = reason.message;
					this.loading = '';
					console.log(reason)
				})
			}
			else{
				this.loading = 'true';
				this.adminlistService.create_firebaase_user(this.item).then(user => {
					this.router.navigate(["/adminlist"]);
					this.loading = '';
					this.notificationsService.success('Added', 'Admin added')
				}).catch(reason => {
					console.log(reason);
					this.fb_error = reason;
					this.loading = '';
					if (this.fb_error == 'The email address is already in use by another account.'){
						this.formErrors.email = this.fb_error;
					}
					if (this.fb_error == 'Password should be at least 6 characters') {
						this.formErrors.password = this.fb_error;
					}
				})	
			}
		}
	}

	onResetPasswd(email){
		var self = this;
		if(confirm('Are you sure? An email will send to this email for reset password. Please inform this email owner to open the email.')){
			this.firebaseService.resetPassword(email).then(function(){
				self.notificationsService.success('Sent', 'Reset password request sent to email.');
			}).catch(e => {
				console.log(e);
			})
		}

	}

	ngAfterViewChecked() {
		this.formChanged();
	}

	formChanged() {
		if (this.currentForm === this.adminForm) { return; }

		this.adminForm = this.currentForm;
		if (this.adminForm) {
			this.adminForm.valueChanges
				.subscribe(data => {
					this.formValidation(true);
					this.fb_error = '';
				});
		}
	}

	formValidation(checkDirty = true) {
		const form = this.adminForm.form;
		for (const field in form.controls) {
			const control = form.get(field)
			if (control) {
				if (checkDirty && !control.dirty) {
					continue;
				}
				this.formErrors[field] = '';
				if (!control.valid) {
					const messages = this.validationMessages[field] || {};
					for (const key in control.errors) {
						this.formErrors[field] += messages[key] + ' ';
					}
				}
			}
		}

		return form.valid;
	}

	formErrors = {
		'fullname': '',
		'email': '',
		'password': '',
	};

	validationMessages = {
		'fullname': {
			'required':'This field is required.',
		},
		'email': {
			'required':'This field is required.',
			'pattern' : 'Please provide a valid email address'
		},
		'password': {
			'required':'This field is required.',
		},
	};

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/adminlist/adminlist-add-edit/adminlist-add-edit.component.ts